import { ImageProps } from './Image.models';
import { Img } from './Image.styles';

const Image: React.FC<ImageProps> = (props) => <Img src={props.src} />;

export default Image;
